export default "__VITE_ASSET__BEGnKcxu__"